import React from 'react';

import {useSelector} from 'react-redux';

import {SUPPORT_CENTER_ITEMS} from 'static/three-oh/src/components/GlobalLayout/GlobalLayoutV2/NavigationBar/shared/constants';
import {
  SupportCenterChatButton
} from 'static/three-oh/src/components/GlobalLayout/GlobalLayoutV2/NavigationBar/SupportCenter/SupportCenterChatButton';
import {
  SupportCenterItem
} from 'static/three-oh/src/components/GlobalLayout/GlobalLayoutV2/NavigationBar/SupportCenter/SupportCenterItem';
import {
  popoutContainerCss,
  supportCenterUnorderedListCss,
  supportChatInfoTextCss,
  supportChatSectionCss,
  supportTitleCss
} from 'static/three-oh/src/components/GlobalLayout/GlobalLayoutV2/NavigationBar/SupportCenter/SupportCenterPopout/SupportCenterPopout.styles';
import {
  useSalesforceChatSupport,
  SALESFORCE_CHAT_START,
  SALESFORCE_CHAT_END
} from 'static/three-oh/src/components/SalesforceChatSupport';

import {getUserProperties, getUser} from '../../../../../../modules/selectors/userSelectors';

const SupportCenterPopout = () => {
  const user = useSelector((state) => getUser(state));
  const userProperties = useSelector((state) => getUserProperties(state));
  const {isChatReady, launchChat} = useSalesforceChatSupport();

  const shouldShowSupportChatButton =
    isChatReady &&
    !userProperties?.isUserLoading &&
    !userProperties?.isStudent &&
    !userProperties?.isLiteUser;

  return (
    <div className={popoutContainerCss}>
      <div className={supportTitleCss}>Support</div>

      <ul className={supportCenterUnorderedListCss}>
        {SUPPORT_CENTER_ITEMS.filter((item) =>
          typeof item.enabled === 'function'
            ? item.enabled(user, userProperties)
            : item.enabled)
          .map(({title, href, openInNewTab, ItemIcon}, index) => (
            <SupportCenterItem title={title} href={href} ItemIcon={ItemIcon} openInNewTab={openInNewTab} key={index} />
          ))}
        {shouldShowSupportChatButton ? (
          <li className={supportChatSectionCss}>
            <SupportCenterChatButton launchChat={launchChat} />
            <span className={supportChatInfoTextCss}>
              Available from Monday to Friday - {SALESFORCE_CHAT_START}am to {SALESFORCE_CHAT_END - 12}pm EST
            </span>
          </li>
        ) : null}
      </ul>
    </div>
  );
};

SupportCenterPopout.displayName = 'SupportCenterPopout';
export {SupportCenterPopout};
